import { Grid } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import React, { useEffect } from 'react'
import { useClientApi } from '../../hooks/useClientApi'
import { useClientFilters } from '../../hooks/useClientFilters'
import { useCurrencyApi } from '../../hooks/useCurrencyApi'
import { ClientTile } from './ClientTile'
import { useSelector } from '../../redux/hooks/useSelector'
import { LoadingIndicator } from '../common/LoadingIndicator'
import { Territory } from '../../redux/reducers/territories'

const useStyles = makeStyles(theme => ({
  clientTable: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(min(340px, 100%), 1fr))',
    gap: theme.spacing(2),
  },
}))

interface ClientDisplayProps {
  territoryChange: Territory | undefined
}

export const ClientDisplay: React.FC<ClientDisplayProps> = ({territoryChange}) => {
  const classes = useStyles()
  const clients = useClientFilters()
  const { getClients } = useClientApi()
  const { getRates } = useCurrencyApi()
  const loading = useSelector(state => state.clients.loading)

  useEffect(() => {
    getClients()
  }, [territoryChange])

  useEffect(() => {
    getRates('CZK')
  }, [])

  useEffect(() => {}, [clients])

  return (
    <div>
      {loading && <LoadingIndicator />}

      {!loading && (
        <div className={classes.clientTable}>
          {clients.map((client, index) => (
            <ClientTile client={client} key={index} />
          ))}
        </div>
      )}
    </div>
  )
}
